import { MongoObservable } from 'meteor-rxjs';
import { Employment } from '../models/employment';

export const Employments = new MongoObservable.Collection<Employment>(
  'employments',
);

if (Meteor.isServer) {
  // indexes of dispoEmploymentAccessQuery which should (at least partially) be prefixed to all server queries to ensure access of jobs
  Employments.rawCollection().createIndex({ 'customer.id': 1 });
  Employments.rawCollection().createIndex({ 'invitees.customer.id': 1 });
  Employments.rawCollection().createIndex({
    'transfers.targetCustomer.id': 1,
    'transfers.transferredAt': 1,
  });
  Employments.rawCollection().createIndex({
    ownerCustomerIds: 1,
  });
  // indexes for pooler access query
  Employments.rawCollection().createIndex({
    'invitees.userId': 1,
    'invitees.hiddenForPooler': 1,
  });
}
